var scriptsLoaded = false;

function loadScripts(e) {
    if (scriptsLoaded || (e && !e.isTrusted)) return;
    scriptsLoaded = true;

    setTimeout(function () {
    loadCSS("//thesleepcompany.in/cdn/shop/t/537/assets/simply.css?v=79172038329448110321782208917");
    loadScript("https://cdnjs.cloudflare.com/ajax/libs/crypto-js/4.1.1/crypto-js.min.js");
    loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/uid.js?v=30942278962362555661767598174");
    loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/predictive-search.js?v=71507557593871791981763017396");
    loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/details-modal.js?v=4511761896672669691729965627");
    loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/index.bundle.gift.js?v=161516786666622533971764678850");
    loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/customescript.js?v=161200066834739818931741335999");
    loadScript('https://bridge.shopflo.com/js/shopflo.bundle.js');
    loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/customTSC.js?v=160295495590987776141729965629");
    loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/compare.js?v=106625069283169512291729965633");
    loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/noteshopflo.js?v=175285957388106889401741336002");
    loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/global.events.js?v=24694680730709280421763017395");
    loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/global.js?v=75764989038244340111758201150");
    loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/chair-featured-collection-tabs-section-javascript.js?v=75509443037537454311753268011");
    loadCSS("//thesleepcompany.in/cdn/shop/t/537/assets/salearrangecallback.css?v=52112704097415008351793596279");
    // loadScript("https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js");
    loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/salearrangecallback.js?v=68474444134528594961793277289");
    loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/extrajsfromthemejs.js?v=49061839294990908061755775277");
    loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/homepage-review-custom-slider.js?v=38852817309244625401755760116");
    loadCSS("//thesleepcompany.in/cdn/shop/t/537/assets/homepage-review-custom-slider-stylesheet.css?v=149705412114606544391749556471");
    loadScript("//thesleepcompany.in/cdn/shop/t/537/assets/new-faq-section-javascript.js?v=134827745232528592471749556472");
    loadScript("https://cdn.shopify.com/extensions/78d1a909-02f9-430b-a819-8b063adf2e65/hulk-form-builder-3/assets/form-builder-script.js");
    loadScriptWithCallBack('https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js', function () {
      $('.sdst-slick-slider').slick({
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
          arrows: false,
          centerMode: true,
          centerPadding: 0,
          responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 400,
              settings: {
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
        $('.placeholder-slk-prnt').css({ opacity: '0' });
        $('.onrendered-slider-prnt').css({ opacity: '1' });
      });
    loadCSS("//thesleepcompany.in/cdn/shop/t/537/assets/Customestyle.css?v=13259755675549689211790590878");
    

    // Quinn App Defer
    try {
      Quinn.functions.renderQuinnWidgets();
    } catch (error) {
      console.error("Quinn app error ==> ", error);

      setTimeout(() => {
        try {
          Quinn.functions.renderQuinnWidgets();
        } catch (error) {
          console.log("Quinn app error in debounce ==> ", error);
        }
      }, 2000);
    }
  }, 10);


  // Remove event listeners after scripts are loaded
  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);
}

// Check if the user is beyond 400px from the top
if (window.scrollY >= 400) {
  loadScripts(); // Load immediately if user is already past 400px
} else {
  // Wait for user interaction
  document.addEventListener('mouseover', loadScripts);
  document.addEventListener('click', loadScripts);
  document.addEventListener('scroll', loadScripts);
}

function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  document.head.appendChild(script);
}

function loadScriptWithCallBack(src, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = callback || function () {};
  document.head.appendChild(script);
}

function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}